import { reduxForm } from 'redux-form'
import { withProps } from 'recompose'
import { compose } from 'redux'
import { COMMUNICATION_PREFERENCES_FORM } from './constants'
import CommunicationPreferencesForm from './CommunicationPreferencesForm'
import { getCommunicationPreferencesFormInitialValues } from './helpers'

const withInitialValues = withProps(({ appointmentReminder, savingAndDiscounts }) => ({
  initialValues: getCommunicationPreferencesFormInitialValues(appointmentReminder, savingAndDiscounts)
}))

export default compose(
  withInitialValues,
  reduxForm({
    form: COMMUNICATION_PREFERENCES_FORM
  })
)(CommunicationPreferencesForm)
